import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui'
import { useToast } from '@/hooks'
import { useInsightsMutations, useProject } from '@/modules/projects'
import { useDialogActions, useDialogIsOpen } from '@/stores'

const dialogId = 'regenerate-insights'

export const RegenerateInsightsDialog = () => {
  const { successToast, errorToast } = useToast()
  const { createInsights } = useInsightsMutations()
  const { closeDialog } = useDialogActions()
  const project = useProject()
  const open = useDialogIsOpen(dialogId)

  const handleSubmit = async () => {
    if (!project?.slug) return

    try {
      await createInsights(project.slug)
      successToast('Regenerating insights...')
      closeDialog(true)
    } catch (error) {
      errorToast('Failed to regenerate insights', error as Error)
    }
  }

  return (
    <Dialog open={open} onOpenChange={(open) => !open && closeDialog()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Regenerate Insights?</DialogTitle>
          <DialogDescription>
            This will regenerate the insights. This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end gap-2 pt-4">
          <Button theme="outline" onClick={() => closeDialog()}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} theme="danger">
            Regenerate Insights
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}

RegenerateInsightsDialog.id = dialogId
